<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              
              <el-form-item label="专利类型">
                  <!-- <el-input style="width: 177px" v-model="queryForm.patentType"></el-input> -->
                  <el-select
                    size="small"
                    v-model="queryForm.patentType"
                    style="width: 177px"
                  >
                    <el-option
                      v-for="(item,index) in businessTypeEnum"
                      :key="index"
                      :label="item.value"
                      :value="item.key"
                    ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="案卷号">
                  <el-input style="width: 177px" v-model="queryForm.archiveNo"></el-input>
              </el-form-item>
              <el-form-item label="申请人">
                  <el-input style="width: 177px" v-model="queryForm.applyEntity"></el-input>
              </el-form-item>
              <el-form-item label="申请日期">
                  <!-- <el-input  v-model="queryForm.applyDate"></el-input> -->
                  <el-date-picker
                    style="width: 177px"
                    v-model="queryForm.applyDate"
                    type="date"
                    value-format="yyyy.M.d"
                    placeholder="选择日期">
                  </el-date-picker>
              </el-form-item>
              <el-form-item
                label="申请区间"
                prop="startApplyDate"
              >
                <!-- <el-input
                  size="small"
                  v-model="propertyPatent.applyStatus"
                  :disabled="propertyPatentState == 'check'"
                  style="width: 177px"
                ></el-input> -->
                <el-date-picker
                  v-model="dataLabel1"
                  type="daterange"
                  range-separator="至"
                  format='yyyy-MM-dd'
                  style="width: 177px"
                  value-format='yyyy-MM-dd'
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="申请号">
                  <el-input style="width: 177px" v-model="queryForm.applyNo"></el-input>
              </el-form-item>
			  <el-form-item label="专利名称">
			      <el-input style="width: 177px" v-model="queryForm.patentName"></el-input>
			  </el-form-item>
              <el-form-item label="证件信息">
                  <el-input style="width: 177px" v-model="queryForm.certificateInfo"></el-input>
              </el-form-item>
              <el-form-item label="申请地址">
                  <el-input style="width: 177px" v-model="queryForm.applyAddress"></el-input>
              </el-form-item>
              <el-form-item label="邮编">
                  <el-input style="width: 177px" v-model="queryForm.postCode"></el-input>
              </el-form-item>
              <el-form-item label="受理情况">
                  <!-- <el-input  v-model="queryForm.acceptStatus"></el-input> -->
                  <el-select placeholder="请选择状态" clearable style="width: 177px"
                    size="small" v-model="queryForm.acceptStatus">
                    <el-option v-for='(item, index) in acceptStatusEnum' :key='index' :label="item.value"
                      :value="item.key">
                    </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="申请费缴纳截止时间">
                  <el-input style="width: 177px" v-model="queryForm.applyfeeEnddate"></el-input>
              </el-form-item>
              <el-form-item label="审核情况">
                  <!-- <el-input  v-model="queryForm.trialStatus"></el-input> -->
                  <el-select placeholder="请选择状态" clearable style="width: 177px"
                      size="small" v-model="queryForm.trialStatus">
                      <el-option v-for='(item, index) in trialStatusEnum' :key='index' :label="item.value" :value="item.key"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="授权情况">
                  <!-- <el-input  v-model="queryForm.authorizeStatus"></el-input> -->
                  <el-select placeholder="请选择状态" clearable style="width: 177px"
                      size="small" v-model="queryForm.authorizeStatus">
                      <el-option v-for='(item, index) in authorizeStatusEnum' :key='index' :label="item.value"
                        :value="item.key">
                      </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="证书情况">
                  <!-- <el-input  v-model="queryForm.certificateStatus"></el-input> -->
                  <el-select placeholder="请选择状态" clearable style="width: 177px"
                    size="small" v-model="queryForm.certificateStatus">
                    <el-option v-for='(item, index) in certificateStatusEnum' :key='index' :label="item.value"
                      :value="item.key">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="业务员">
                  <el-input style="width: 177px" v-model="queryForm.saleMan"></el-input>
              </el-form-item>
              <el-form-item label="授权费年费情况">
                  <el-input style="width: 177px" v-model="queryForm.authorizefeeAnnualfeeSituation"></el-input>
              </el-form-item>
              <el-form-item label="工程师">
                  <el-input style="width: 177px" v-model="queryForm.engineer"></el-input>
              </el-form-item>
              <el-form-item label="专利代理人">
                  <el-input style="width: 177px" v-model="queryForm.patentAgent"></el-input>
              </el-form-item>
              <el-form-item label="质检人">
                  <el-input style="width: 177px" v-model="queryForm.qualityInspector"></el-input>
              </el-form-item>
              <el-form-item label="联系人">
                  <el-input style="width: 177px" v-model="queryForm.contact"></el-input>
              </el-form-item>
              <el-form-item label="联系电话">
                  <el-input style="width: 177px" v-model="queryForm.telephone"></el-input>
              </el-form-item>
              <el-form-item label="QQ号">
                  <el-input style="width: 177px" v-model="queryForm.qq"></el-input>
              </el-form-item>
              <el-form-item label="邮箱">
                  <el-input style="width: 177px" v-model="queryForm.email"></el-input>
              </el-form-item>
              <el-form-item label="传真">
                  <el-input style="width: 177px" v-model="queryForm.fax"></el-input>
              </el-form-item>
              <el-form-item label="签单价格">
                  <el-input style="width: 177px" v-model="queryForm.signPrice"></el-input>
              </el-form-item>
              <el-form-item label="提醒日期">
                  <!-- <el-input  v-model="queryForm.nextPayTime"></el-input> -->
                  <el-date-picker
                    style="width: 177px"
                    v-model="queryForm.reminderDate"
                    type="date"
                    value-format="yyyy.M.d"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              <el-form-item label="缴费情况">
                  <el-input style="width: 177px" v-model="queryForm.paySituation"></el-input>
              </el-form-item>
              <el-form-item label="专利状态">
                  <!-- <el-input  v-model="queryForm.patentStatus"></el-input> -->
                  <el-select placeholder="请选择状态" clearable style="width: 177px"
                      size="small" v-model="queryForm.patentStatus">
                      <el-option v-for='(item, index) in patentStatusEnum' :key='index' :label="item.value" :value="item.key"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="紧急状态">
                  <!-- <el-input  v-model="queryForm.urgentStatus"></el-input> -->
                  <el-select placeholder="请选择状态" clearable style="width: 177px"
                      size="small" v-model="queryForm.urgentStatus">
                      <el-option v-for='(item, index) in urgentStatusEnum' :key='index' :label="item.value" :value="item.key"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="所属公司">
                  <!-- <el-input  v-model="queryForm.companyId"></el-input> -->
                  <el-select
                    placeholder='请选择所属公司'
                    clearable
                    style='width: 177px'
                    size='small'
                    v-model='queryForm.companyId'
                  >
                    <el-option
                      v-for='(item,index) in companyList'
                      :key='index'
                      :label='item.companyName'
                      :value='item.id'
                    >
                    </el-option>
            </el-select>
              </el-form-item>
              <el-form-item label="备注">
                  <el-input style="width: 177px" v-model="queryForm.remarks"></el-input>
              </el-form-item>
              <el-form-item label="提醒类型">
                  <el-select placeholder="请选择类型" clearable style="width: 177px"
                      size="small" v-model="queryForm.reminderType">
                      <el-option v-for='(item, index) in propertyReminderType' :key='index' :label="item.value" :value="item.key"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getPropertyPatentList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addPropertyPatent"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editPropertyPatent(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deletePropertyPatent(null)"
        >删除</el-button>
      </div>

      <div class="icon-group" style="display: flex">
            <!-- <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload> -->
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          title="导入数据"
          @click="isImport"
        >
          <Icon color="#606266">
            <ArrowExportUp24Regular />
          </Icon>
        </span>
        <span
          title="导出数据"
          class="icon-box"
          @click="exportPropertyPatentList"
        >
          <Icon color="#606266">
            <ArrowDownload24Regular />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshPropertyPatentList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="propertyPatentList"
      :row-class-name="tableRowClassName"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="patentType"
        label="专利类型"
        width="180"
      >
        <template slot-scope="scope">
          {{businessTypeEnums(scope.row.patentType)}}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="archiveNo"
        label="案卷号"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="applyEntity"
        label="申请人"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="applyDate"
        label="申请日期"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="applyNo"
        label="申请号"
        width="180"
      > </el-table-column>
	  <el-table-column
	    :show-overflow-tooltip="true"
	    align="center"
	    prop="patentName"
	    label="专利名称"
	    width="180"
	  > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="certificateInfo"
        label="证件信息"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="applyAddress"
        label="申请地址"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="postCode"
        label="邮编"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="acceptStatus"
        label="受理情况"
        width="180"
      >
        <template slot-scope="scope">
          {{ acceptStatusEnums(scope.row.acceptStatus) }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="applyfeeEnddate"
        label="申请费缴纳截止时间"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="trialStatus"
        label="审核情况"
        width="180"
      > 
        <template slot-scope="scope">
          {{ trialStatusEnums(scope.row.trialStatus) }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="authorizeStatus"
        label="授权情况"
        width="180"
      >
        <template slot-scope="scope">
          {{ authorizeStatusEnums(scope.row.authorizeStatus) }}
        </template> 
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="certificateStatus"
        label="证书情况"
        width="180"
      > 
        <template slot-scope="scope">
          {{ certificateStatusEnums(scope.row.certificateStatus) }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="saleMan"
        label="业务员"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="authorizefeeAnnualfeeSituation"
        label="授权费年费情况"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="engineer"
        label="工程师"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="patentAgent"
        label="专利代理人"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="qualityInspector"
        label="质检人"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="remarks"
        label="备注"
        width="180"
      > </el-table-column>
      <el-table-column
        v-if="isSa"
        :show-overflow-tooltip="true"
        align="center"
        prop="contact"
        label="联系人"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        v-if="isSa"
        prop="telephone"
        label="联系电话"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        v-if="isSa"
        prop="qq"
        label="QQ号"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="email"
        v-if="isSa"
        label="邮箱"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="fax"
        v-if="isSa"
        label="传真"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="signPrice"
        v-if="isSa"
        label="签单价格"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="reminderDate"
        label="提醒日期"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="paySituation"
        label="缴费情况"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="patentStatus"
        label="专利状态"
        width="180"
      > 
        <template slot-scope="scope">
          {{ patentStatusEnums(scope.row.patentStatus) }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="urgentStatus"
        label="紧急状态"
        width="180"
      > 
        <template slot-scope="scope">
          {{ urgentStatusEnums(scope.row.urgentStatus) }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="companyId"
        label="所属公司"
        width="180"
      >
        <template slot-scope="scope">
          {{ getCompanyLists(scope.row.companyId) }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkPropertyPatent(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editPropertyPatent(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deletePropertyPatent(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="propertyPatentStates[propertyPatentState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="propertyPatent"
          ref="propertyPatentForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="专利名称"
            prop="patentName"
          >
            <el-input
              style="width: 177px"
              size="small"
              v-model="propertyPatent.patentName"
              :disabled="propertyPatentState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="专利类型"
            prop="patentType"
          >
            <!-- <el-input
              size="small"
              v-model="propertyPatent.patentType"
              :disabled="propertyPatentState == 'check'"
              style="width: 177px"
            ></el-input> -->
            <el-select
              size="small"
              v-model="propertyPatent.patentType"
              :disabled="propertyPatentState == 'check'"
              style="width: 177px"
            >
              <el-option
                v-for="(item,index) in businessTypeEnum"
                :key="index"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="案卷号"
            prop="archiveNo"
          >
            <el-input
              size="small"
              v-model="propertyPatent.archiveNo"
              :disabled="propertyPatentState == 'check'"
              style="width: 177px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="申请人"
            prop="applyEntity"
          >
            <el-input
              size="small"
              v-model="propertyPatent.applyEntity"
              :disabled="propertyPatentState == 'check'"
              style="width: 177px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="申请日期"
            prop="applyDate"
          >
            <!-- <el-input
              size="small"
              v-model="propertyPatent.applyDate"
              :disabled="propertyPatentState == 'check'"
            ></el-input> -->
            <el-date-picker
              style="width: 177px"
              :clearable="false"
              :disabled="propertyPatentState == 'check'"
              v-model="propertyPatent.applyDate"
              type="date"
              value-format="yyyy.M.d"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="申请号"
            prop="applyNo"
          >
            <el-input
              size="small"
              v-model="propertyPatent.applyNo"
              :disabled="propertyPatentState == 'check'"
              style="width: 177px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="证件信息"
            prop="certificateInfo"
          >
            <el-input
              size="small"
              v-model="propertyPatent.certificateInfo"
              :disabled="propertyPatentState == 'check'"
              style="width: 177px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="申请地址"
            prop="applyAddress"
          >
            <el-input
              size="small"
              v-model="propertyPatent.applyAddress"
              :disabled="propertyPatentState == 'check'"
              style="width: 177px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="邮编"
            prop="postCode"
          >
            <el-input
              size="small"
              v-model="propertyPatent.postCode"
              :disabled="propertyPatentState == 'check'"
              style="width: 177px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="受理情况"
            prop="acceptStatus"
          >
            <!-- <el-input
              size="small"
              v-model="propertyPatent.acceptStatus"
              :disabled="propertyPatentState == 'check'"
            ></el-input> -->
            <el-select placeholder="请选择状态" :disabled="propertyPatentState == 'check'" clearable style="width: 177px"
                size="small" v-model="propertyPatent.acceptStatus">
                <el-option v-for='(item, index) in acceptStatusEnum' :key='index' :label="item.value"
                  :value="item.key">
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="申请费缴纳截止时间"
            prop="applyfeeEnddate"
          >
            <el-input
              size="small"
              v-model="propertyPatent.applyfeeEnddate"
              :disabled="propertyPatentState == 'check'"
              style="width: 177px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="审核情况"
            prop="trialStatus"
          >
            <!-- <el-input
              size="small"
              v-model="propertyPatent.trialStatus"
              :disabled="propertyPatentState == 'check'"
            ></el-input> -->
            <el-select placeholder="请选择状态" :disabled="propertyPatentState == 'check'" clearable style="width: 177px"
                size="small" v-model="propertyPatent.trialStatus">
                <el-option v-for='(item, index) in trialStatusEnum' :key='index' :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="授权情况"
            prop="authorizeStatus"
          >
            <!-- <el-input
              size="small"
              v-model="propertyPatent.authorizeStatus"
              :disabled="propertyPatentState == 'check'"
            ></el-input> -->
            <el-select placeholder="请选择状态" :disabled="propertyPatentState == 'check'" clearable style="width: 177px"
                size="small" v-model="propertyPatent.authorizeStatus">
                <el-option v-for='(item, index) in authorizeStatusEnum' :key='index' :label="item.value"
                  :value="item.key">
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="证书情况"
            prop="certificateStatus"
          >
            <!-- <el-input
              size="small"
              v-model="propertyPatent.certificateStatus"
              :disabled="propertyPatentState == 'check'"
            ></el-input> -->
            <el-select placeholder="请选择状态" :disabled="propertyPatentState == 'check'" clearable style="width: 177px"
                size="small" v-model="propertyPatent.certificateStatus">
                <el-option v-for='(item, index) in certificateStatusEnum' :key='index' :label="item.value"
                  :value="item.key">
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="业务员"
            prop="saleMan"
          >
            <el-input
              size="small"
              v-model="propertyPatent.saleMan"
              :disabled="propertyPatentState == 'check'"
              style="width: 177px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="授权费年费情况"
            prop="authorizefeeAnnualfeeSituation"
          >
            <el-input
              size="small"
              v-model="propertyPatent.authorizefeeAnnualfeeSituation"
              :disabled="propertyPatentState == 'check'"
              style="width: 177px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="工程师"
            prop="engineer"
          >
            <el-input
              size="small"
              v-model="propertyPatent.engineer"
              :disabled="propertyPatentState == 'check'"
              style="width: 177px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="专利代理人"
            prop="patentAgent"
          >
            <el-input
              size="small"
              v-model="propertyPatent.patentAgent"
              :disabled="propertyPatentState == 'check'"
              style="width: 177px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="质检人"
            prop="qualityInspector"
          >
            <el-input
              size="small"
              v-model="propertyPatent.qualityInspector"
              :disabled="propertyPatentState == 'check'"
              style="width: 177px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="联系人"
            prop="contact"
          >
            <el-input
              size="small"
              v-model="propertyPatent.contact"
              :disabled="propertyPatentState == 'check'"
              style="width: 177px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="联系电话"
            prop="telephone"
          >
            <el-input
              size="small"
              v-model="propertyPatent.telephone"
              :disabled="propertyPatentState == 'check'"
              style="width: 177px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="QQ号"
            prop="qq"
          >
            <el-input
              size="small"
              v-model="propertyPatent.qq"
              :disabled="propertyPatentState == 'check'"
              style="width: 177px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="邮箱"
            prop="email"
          >
            <el-input
              size="small"
              v-model="propertyPatent.email"
              :disabled="propertyPatentState == 'check'"
              style="width: 177px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="传真"
            prop="fax"
          >
            <el-input
              size="small"
              v-model="propertyPatent.fax"
              :disabled="propertyPatentState == 'check'"
              style="width: 177px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="签单价格"
            prop="signPrice"
          >
            <el-input
              size="small"
              v-model="propertyPatent.signPrice"
              :disabled="propertyPatentState == 'check'"
              style="width: 177px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="提醒日期"
            prop="reminderDate"
          >
            <!-- <el-input
              size="small"
              v-model="propertyPatent.nextPayTime"
              :disabled="propertyPatentState == 'check'"
            ></el-input> -->
            <el-date-picker
              style="width: 177px"
              :disabled="propertyPatentState == 'check'"
              v-model="propertyPatent.reminderDate"
              type="date"
              value-format="yyyy.M.d"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="缴费情况"
            prop="paySituation"
          >
            <!-- <el-input
              size="small"
              v-model="propertyPatent.paySituation"
              :disabled="propertyPatentState == 'check'"
               style="width: 177px"
            ></el-input> -->
            <el-select
              v-if="propertyPatentState != 'check'"
              v-model="propertyPatent.paySituation"
              :disabled="propertyPatentState == 'check' || !(propertyPatent.patentType != '' && propertyPatent.applyDate!='')"
              multiple
              collapse-tags
              @change="xx"
              collapse-tags-tooltip
              placeholder="Select"
              style="width: 177px"
            >
              <el-option
                v-for="item in year"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
            <el-input
              v-else
              size="small"
              v-model="propertyPatent.paySituation"
              :disabled="propertyPatentState == 'check'"
               style="width: 177px"
            ></el-input>
            <!-- <el-select style="width: 177px" collapse-tags v-model="propertyPatent.paySituation" :disabled="propertyPatentState == 'check'" multiple placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item
            label="专利状态"
            prop="patentStatus"
          >
            <!-- <el-input
              size="small"
              v-model="propertyPatent.patentStatus"
              :disabled="propertyPatentState == 'check'"
            ></el-input> -->
            <el-select placeholder="请选择状态" :disabled="propertyPatentState == 'check'" clearable style="width: 177px"
                size="small" v-model="propertyPatent.patentStatus">
                <el-option v-for='(item, index) in patentStatusEnum' :key='index' :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="紧急状态"
            prop="urgentStatus"
          >
            <!-- <el-input
              size="small"
              v-model="propertyPatent.urgentStatus"
              :disabled="propertyPatentState == 'check'"
            ></el-input> -->
            <el-select placeholder="请选择状态" ref="ses" :disabled="propertyPatentState == 'check'" clearable style="width: 177px"
                size="small" v-model="propertyPatent.urgentStatus">
                <el-option v-for='(item, index) in urgentStatusEnum' :key='index' :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="所属公司"
            prop="companyId"
          >
            <!-- <el-input
              size="small"
              v-model="propertyPatent.companyId"
              :disabled="propertyPatentState == 'check'"
            ></el-input> -->
            <el-select
              placeholder='请选择所属公司'
              clearable
              style='width: 177px'
              size='small'
              v-model='propertyPatent.companyId'
              :disabled="propertyPatentState == 'check'"
            >
              <el-option
                v-for='(item,index) in companyList'
                :key='index'
                :label='item.companyName'
                :value='item.id'
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="备注"
            prop="remarks"
          >
          <el-input
              size="small"
              type="textarea"
              style="width: 42vw;"
              :rows="6"
              v-model="propertyPatent.remarks"
              :disabled="propertyPatentState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="propertyPatentState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
    <!-- 导入 -->
    <el-dialog
            title="导入数据"
            :visible.sync="isImportDate"
            width="80%"
            @close="closeDialog1"
            >
            <div style="border-bottom: 1px solid #eee;display: flex;align-items: center;">
                <el-form
                :model="OnUploads"
                :rules="rules"
                ref="uupp"
                style="height: 45px;"
                label-width="100px"
                size="small"
                :inline="true"
                >
                <el-form-item
                    label="所属公司"
                    prop="companyId"
                >
                    <!-- <el-input
                    size="small"
                    v-model="propertyPatent.companyId"
                    :disabled="propertyPatentState == 'check'"
                    ></el-input> -->
                    <el-select
                        placeholder='请选择所属公司'
                        clearable
                        style='width: 180px'
                        size='small'
                        v-model='OnUploads.companyId'
                        >
                        <el-option
                            v-for='(item,index) in companyList'
                            :key='index'
                            :label='item.companyName'
                            :value='item.id'
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    label="专利文件"
                    prop="tips"
                >
                    <!-- <el-input
                    style="width: 177px"
                    size="small"
                    v-model="propertyPatent.patentName"
                    :disabled="propertyPatentState == 'check'"
                    ></el-input> -->
                    <el-upload
                        class="upload-demo"
                        action="#"
                        :auto-upload="false"
                        :on-change="upload1"
                        :file-list="fileLists"
                        :show-file-list="false">
                        <el-tooltip class="item" effect="dark" content="只允许导入“xls”或“xlsx”格式文件！" placement="bottom">
                            <el-button size="small" type="primary">点击上传</el-button>
                        </el-tooltip>
                        <!-- <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div> -->
                    </el-upload>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="okk">确定</el-button>
                </el-form-item>
                </el-form>
                <span v-if="counts">上传成功：{{ successList.length }}条，</span>
                <span v-if="counts">上传失败：{{ failList.length }}</span>
            </div>
            <el-tabs v-model="check" type="card">
              <el-tab-pane label="上传成功" name="true"></el-tab-pane>
              <el-tab-pane label="上传失败" name="false"></el-tab-pane>
            </el-tabs>
            <!-- <div style="margin-top: 10px;">
                <el-button size="small" type="primary" @click="check=true">上传成功</el-button>
                <el-button size="small" type="danger" @click="check=false">上传失败</el-button>
            </div> -->
            <div style="height: 400px;">
                      <!-- 列表数据 -->
                <el-table
                    :data="nowList"
                    :row-class-name="tableRowClassName"
                    row-key="id"
                    border
                    height="100%"
                    :header-row-style="{height: '10px'}"
                    :header-cell-style="{padding: '10px'}"
                    :row-style="{height: '9px'}"
                    :cell-style="{padding: '9px'}"
                    size="small"
                    >
                    <!-- <el-table-column
                        align="center"
                        type="selection"
                        width="60"
                    > </el-table-column> -->
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="patentName"
                        label="专利名称"
                        width="180"
                    > </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="patentType"
                        label="专利类型"
                        width="180"
                    >
                        <template slot-scope="scope">
                        {{businessTypeEnums(scope.row.patentType)}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="archiveNo"
                        label="案卷号"
                        width="180"
                    > </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="applyEntity"
                        label="申请人"
                        width="180"
                    > </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="applyDate"
                        label="申请日期"
                        width="180"
                    > </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="applyNo"
                        label="申请号"
                        width="180"
                    > </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="certificateInfo"
                        label="证件信息"
                        width="180"
                    > </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="applyAddress"
                        label="申请地址"
                        width="180"
                    > </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="postCode"
                        label="邮编"
                        width="180"
                    > </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="acceptStatus"
                        label="受理情况"
                        width="180"
                    >
                        <template slot-scope="scope">
                        {{ acceptStatusEnums(scope.row.acceptStatus) }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="applyfeeEnddate"
                        label="申请费缴纳截止时间"
                        width="180"
                    > </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="trialStatus"
                        label="审核情况"
                        width="180"
                    > 
                        <template slot-scope="scope">
                        {{ trialStatusEnums(scope.row.trialStatus) }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="authorizeStatus"
                        label="授权情况"
                        width="180"
                    >
                        <template slot-scope="scope">
                        {{ authorizeStatusEnums(scope.row.authorizeStatus) }}
                        </template> 
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="certificateStatus"
                        label="证书情况"
                        width="180"
                    > 
                        <template slot-scope="scope">
                        {{ certificateStatusEnums(scope.row.certificateStatus) }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="saleMan"
                        label="业务员"
                        width="180"
                    > </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="authorizefeeAnnualfeeSituation"
                        label="授权费年费情况"
                        width="180"
                    > </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="engineer"
                        label="工程师"
                        width="180"
                    > </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="patentAgent"
                        label="专利代理人"
                        width="180"
                    > </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="qualityInspector"
                        label="质检人"
                        width="180"
                    > </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="remarks"
                        label="备注"
                        width="180"
                    > </el-table-column>
                    <el-table-column
                        v-if="isSa"
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="contact"
                        label="联系人"
                        width="180"
                    > </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        v-if="isSa"
                        prop="telephone"
                        label="联系电话"
                        width="180"
                    > </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        v-if="isSa"
                        prop="qq"
                        label="QQ号"
                        width="180"
                    > </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="email"
                        v-if="isSa"
                        label="邮箱"
                        width="180"
                    > </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="fax"
                        v-if="isSa"
                        label="传真"
                        width="180"
                    > </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="signPrice"
                        v-if="isSa"
                        label="签单价格"
                        width="180"
                    > </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="reminderDate"
                        label="提醒日期"
                        width="180"
                    > </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="paySituation"
                        label="缴费情况"
                        width="180"
                    > </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="patentStatus"
                        label="专利状态"
                        width="180"
                    > 
                        <template slot-scope="scope">
                        {{ patentStatusEnums(scope.row.patentStatus) }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="urgentStatus"
                        label="紧急状态"
                        width="180"
                    > 
                        <template slot-scope="scope">
                        {{ urgentStatusEnums(scope.row.urgentStatus) }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="companyId"
                        label="所属公司"
                        width="180"
                    >
                        <template slot-scope="scope">
                        {{ getCompanyLists(scope.row.companyId) }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="createTime"
                        label="创建时间"
                        width="180"
                    > </el-table-column>
                </el-table>
            </div>
            <div
                slot="footer"
                class="flex justify-end"
            >
                <el-button @click="closeDialog1">关闭</el-button>
            </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectLi from '@/components/gridselect/gidselect.vue';
import { UPLOAD_PATH, UPLOAD_API, USER, PRODUCT, PRODUCT_SEARCH, USER_SEARCH } from '@/utils/constant.js';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelectLi
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetPropertyPatentList();
                this.getPropertyPatentList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetPropertyPatentList();
                this.getPropertyPatentList();
                this.$emit('resetCheckState');
            }
        },
        check(){
            if(this.check == 'true'){
                this.nowList = this.successList
            }else{
                this.nowList = this.failList
            }
        }
    },
    computed:{
      year(){
        if(this.propertyPatent.applyDate != '' && this.propertyPatent.patentType != ''){
          let count = this.getyearsEnum(this.propertyPatent.patentType)
          let arr = []
          let date = new Date(this.propertyPatent.applyDate).getFullYear()
          for (let i = 0; i < count; i++) {
            arr.push(date++)
          }
          return arr
        }
      }
    },
    data() {
            return {
                getColor:[
                  {key:2, value:'green'},
                  {key:4, value:'#ff0000'},
                  {key:3, value:'#E6A23C'},
                  {key:1, value:'#606266'}
                ],
                queryForm:{
                     patentName: '', //专利名称
                     patentType: '', //专利类型
                     archiveNo: '', //案卷号
                     applyEntity: '', //申请人
                     applyDate: '', //申请日期
                     applyNo: '', //申请号
                     certificateInfo: '', //证件信息
                     applyAddress: '', //申请地址
                     postCode: '', //邮编
                     acceptStatus: '', //受理情况
                     applyfeeEnddate: '', //申请费缴纳截止时间
                     trialStatus: '', //审核情况
                     authorizeStatus: '', //授权情况
                     certificateStatus: '', //证书情况
                     saleMan: '', //业务员
                     authorizefeeAnnualfeeSituation: '', //授权费年费情况
                     engineer: '', //工程师
                     patentAgent: '', //专利代理人
                     qualityInspector: '', //质检人
                     remarks: '', //备注
                     contact: '', //联系人
                     telephone: '', //电话
                     qq: '', //QQ号
                     email: '', //邮箱
                     fax: '', //传真
                     signPrice: '', //签单价格
                     reminderDate: '', //下次缴费时间
                     paySituation: '', //缴费情况
                     patentStatus: '', //专利状态
                     urgentStatus: '', //紧急状态
                     companyId: '', //所属公司
                     reminderType:'',
                     startApplyDate:'',
                     endApplyDate:''
                },
                dataLabel1:'',
                OnUploads:{
                  companyId:'',
                  tips:''
                },
                header: {
                token: localStorage.getItem('token')},
                action: UPLOAD_API + UPLOAD_PATH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                propertyPatentState: 'add',
                propertyPatentStates: {
                    add: '新建专利',
                    check: '查看专利',
                    edit: '修改专利'
                },

                multipleSelection: [],
                propertyPatentList: [],
                propertyPatent: {
                    patentName: '', //专利名称
                    patentType: '', //专利类型
                    archiveNo: '', //案卷号
                    applyEntity: '', //申请人
                    applyDate: '', //申请日期
                    applyNo: '', //申请号
                    certificateInfo: '', //证件信息
                    applyAddress: '', //申请地址
                    postCode: '', //邮编
                    acceptStatus: '', //受理情况
                    applyfeeEnddate: '', //申请费缴纳截止时间
                    trialStatus: '', //审核情况
                    authorizeStatus: '', //授权情况
                    certificateStatus: '', //证书情况
                    saleMan: '', //业务员
                    authorizefeeAnnualfeeSituation: '', //授权费年费情况
                    engineer: '', //工程师
                    patentAgent: '', //专利代理人
                    qualityInspector: '', //质检人
                    remarks: '', //备注
                    contact: '', //联系人
                    telephone: '', //电话
                    qq: '', //QQ号
                    email: '', //邮箱
                    fax: '', //传真
                    signPrice: '', //签单价格
                    reminderDate: '', //下次缴费时间
                    paySituation: '', //缴费情况
                    patentStatus: 1, //专利状态
                    urgentStatus: 1, //紧急状态
                    companyId: '', //所属公司
                    createTime: '', //
                    updateTime:''
                },
                btnLoading: false,

                rules: {
                    patentName: [{ required: true, message: '专利名称不能为空', trigger: 'blur' }],
                    patentType: [{ required: true, message: '专利类型不能为空', trigger: 'blur' }],
                    archiveNo: [{ required: true, message: '案卷号不能为空', trigger: 'blur' }],
                    applyEntity: [{ required: true, message: '申请人不能为空', trigger: 'blur' }],
                    applyDate: [{ required: true, message: '申请日期不能为空', trigger: 'blur' }],
                    applyNo: [{ required: true, message: '申请号不能为空', trigger: 'blur' }],
                    certificateInfo: [{ required: true, message: '证件信息不能为空', trigger: 'blur' }],
                    applyAddress: [{ required: true, message: '申请地址不能为空', trigger: 'blur' }],
                    postCode: [{ required: true, message: '邮编不能为空', trigger: 'blur' }],
                    acceptStatus: [{ required: true, message: '受理情况不能为空', trigger: 'blur' }],
                    applyfeeEnddate: [{ required: true, message: '申请费缴纳截止时间不能为空', trigger: 'blur' }],
                    trialStatus: [{ required: true, message: '审核情况不能为空', trigger: 'blur' }],
                    authorizeStatus: [{ required: true, message: '授权情况不能为空', trigger: 'blur' }],
                    certificateStatus: [{ required: true, message: '证书情况不能为空', trigger: 'blur' }],
                    saleMan: [{ required: true, message: '业务员不能为空', trigger: 'blur' }],
                    authorizefeeAnnualfeeSituation: [{ required: true, message: '授权费年费情况不能为空', trigger: 'blur' }],
                    engineer: [{ required: true, message: '工程师不能为空', trigger: 'blur' }],
                    patentAgent: [{ required: true, message: '专利代理人不能为空', trigger: 'blur' }],
                    // qualityInspector: [{ required: true, message: '质检人不能为空', trigger: 'blur' }],
                    // remarks: [{ required: true, message: '备注不能为空', trigger: 'blur' }],
                    contact: [{ required: true, message: '联系人不能为空', trigger: 'blur' }],
                    telephone: [{ required: true, message: '联系电话不能为空', trigger: 'blur' }],
                    // qq: [{ required: true, message: 'QQ号不能为空', trigger: 'blur' }],
                    // email: [{ required: true, message: '邮箱不能为空', trigger: 'blur' }],
                    // fax: [{ required: true, message: '传真不能为空', trigger: 'blur' }],
                    signPrice: [{ required: true, message: '签单价格不能为空', trigger: 'blur' }],
                    reminderDate: [{ required: true, message: '提醒时间不能为空', trigger: 'blur' }],
                    paySituation: [{ required: true, message: '缴费情况不能为空', trigger: 'blur' }],
                    patentStatus: [{ required: true, message: '专利状态不能为空', trigger: 'blur' }],
                    urgentStatus: [{ required: true, message: '紧急状态不能为空', trigger: 'blur' }],
                    companyId: [{ required: true, message: '所属公司不能为空', trigger: 'blur' }],
                    createTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    tips:[{ required: true, message: '文件不能为空', trigger: 'blur' }]
                },
                // 受理状态
                acceptStatusEnum:[],
                // 授权状态
                authorizeStatusEnum:[],
                // 证书状态
                certificateStatusEnum:[],
                // 专利状态
                patentStatusEnum:[],
                // 审核状态
                trialStatusEnum:[],
                // 紧急状态
                urgentStatusEnum:[],
                // 所属公司
                companyList: [],
                businessTypeEnum:[],
                fileList:{},
                fileLists:[],
                propertyReminderType:[],
                isSa:"",
                yearsEnum:[],
                str:'',
                nowList:[],
                successList:[],
                failList:[],
                check: "true",
                counts: false,
                tips:''
            };

        },
        created() {
            this.getPropertyPatentList();
            this.getProductStatusEnum()
            this.getCompanyList();
        },
        methods: {
            xx(val){
              console.log(val,this.str)
            },
            handleChange(file,fileList){
              this.fileLists = fileList
            },
            tableRowClassName({row}){
              if(row.urgentStatus == 2){
                return 'success-row'
              }else if(row.urgentStatus == 3){
                return 'warning-row'
              }else if(row.urgentStatus == 4){
                return 'error-row'
              }
            },
            isImport() {
                this.isImportDate = true;
            },
            closeDialog1(){
                this.fileList = {}
                this.OnUploads = {
                  companyId:'',
                  tips:""
                }
                this.nowList = []
                this.successList = []
                this.failList = []
                this.isImportDate = false
                this.counts = false
                this.getPropertyPatentList();
                // this.tips = ''
            },
            upload1(file){
                console.log(file)
                this.fileList = file
                this.OnUploads.tips = '123'
                console.log(this.OnUploads.tips)
            },
            okk(){
              this.$refs.uupp.validate((valid) => {
                if(valid){
                  let formData = new FormData();
                  formData.append('file',this.fileList.raw)
                  formData.append('companyId',this.OnUploads.companyId)
                  console.log(this.fileList)
                  importDate(`/property/patent/import`,formData).then((res) => {
                      if (res.success) {
                          this.fileLists = []
                          this.successList = res.imported
                          this.failList = res.notimported
                          this.nowList = res.imported
                          this.check = "true"
                          this.counts = true
                          this.OnUploads.tips = ''
                      }else{
                        this.$message.error(res.message)
                      }
                  });
                  }
              })
            },
            retrunColor(key){
              for (const iterator of this.getColor) {
                if(iterator.key == key){
                  return iterator.value
                }
              }
            },
            // 公司列表
            getCompanyList() {
                get('/property/company/findAll').then((res) => {
                    if (res.success) {
                        // console.log(res.list)
                        this.companyList = res.list
                    }
                })
            },
            // 公司列表
            getCompanyLists(type){
              for (let i = 0; i < this.companyList.length; i++) {
                if(this.companyList[i].id == type){
                    return this.companyList[i].companyName
                }
              }
            },
            // 获取状态枚举
            getProductStatusEnum() {
              // 时间枚举
              get('/mpp/utils/getEnum', {
                enumType: 'property_business_year',
              }).then((res) => {
                if (res.success) {
                  // console.log(res.enumList)
                  this.yearsEnum = res.enumList
                }
              })
              // 受理状态
              get('/mpp/utils/getEnum', {
                enumType: 'property_accept_status',
              }).then((res) => {
                if (res.success) {
                  console.log(res.enumList)
                  this.acceptStatusEnum = res.enumList
                }
              })
              // 授权状态
              get('/mpp/utils/getEnum', {
                enumType: 'property_authorize_status',
              }).then((res) => {
                if (res.success) {
                  // console.log(res.enumList)
                  this.authorizeStatusEnum = res.enumList
                }
              })
              // 证书状态
              get('/mpp/utils/getEnum', {
                enumType: 'property_certificate_status',
              }).then((res) => {
                if (res.success) {
                  // console.log(res.enumList)
                  this.certificateStatusEnum = res.enumList
                }
              })
              // 专利状态
              get('/mpp/utils/getEnum', {
                enumType: 'property_patent_status',
              }).then((res) => {
                if (res.success) {
                  // console.log(res.enumList)
                  this.patentStatusEnum = res.enumList
                }
              })
              // 审核状态
              get('/mpp/utils/getEnum', {
                enumType: 'property_trial_status',
              }).then((res) => {
                if (res.success) {
                  // console.log(res.enumList)
                  this.trialStatusEnum = res.enumList
                }
              })
              // 紧急状态
              get('/mpp/utils/getEnum', {
                enumType: 'property_urgent_status',
              }).then((res) => {
                if (res.success) {
                  // console.log(res.enumList)
                  this.urgentStatusEnum = res.enumList
                }
              })
              // 专利类型
              get('/mpp/utils/getEnum', {
                enumType: 'property_business_type',
              }).then((res) => {
                if (res.success) {
                  // console.log(res.enumList)
                  this.businessTypeEnum = res.enumList
                }
              })
              // 提醒
              get('/mpp/utils/getEnum', {
                enumType: 'property_reminder_type',
              }).then((res) => {
                if (res.success) {
                  // console.log(res.enumList)
                  this.propertyReminderType = res.enumList
                }
              })
            },
            // 受理状态
            acceptStatusEnums(type){
              // console.log(type)
              for (let i = 0; i < this.acceptStatusEnum.length; i++) {
                if(this.acceptStatusEnum[i].key == type){
                    return this.acceptStatusEnum[i].value
                }
              }
            },
            // 时间类型
            getyearsEnum(type){
              for (let i = 0; i < this.yearsEnum.length; i++) {
                if(this.yearsEnum[i].key == type){
                    return this.yearsEnum[i].value
                }
              }
            },
            businessTypeEnums(type){
              for (let i = 0; i < this.businessTypeEnum.length; i++) {
                if(this.businessTypeEnum[i].key == type){
                    return this.businessTypeEnum[i].value
                }
              }
            },
            // 授权状态
            authorizeStatusEnums(type){
              for (let i = 0; i < this.authorizeStatusEnum.length; i++) {
                if(this.authorizeStatusEnum[i].key == type){
                    return this.authorizeStatusEnum[i].value
                }
              }
            },
            // 证书状态
            certificateStatusEnums(type){
              for (let i = 0; i < this.certificateStatusEnum.length; i++) {
                if(this.certificateStatusEnum[i].key == type){
                    return this.certificateStatusEnum[i].value
                }
              }
            },
            // 专利状态
            patentStatusEnums(type){
              for (let i = 0; i < this.patentStatusEnum.length; i++) {
                if(this.patentStatusEnum[i].key == type){
                    return this.patentStatusEnum[i].value
                }
              }
            },
            // 审核状态
            trialStatusEnums(type){
              for (let i = 0; i < this.trialStatusEnum.length; i++) {
                if(this.trialStatusEnum[i].key == type){
                    return this.trialStatusEnum[i].value
                }
              }
            },
            // 紧急状态
            urgentStatusEnums(type){
              for (let i = 0; i < this.urgentStatusEnum.length; i++) {
                if(this.urgentStatusEnum[i].key == type){
                    return this.urgentStatusEnum[i].value
                }
              }
            },
            search(){
                this.isSearch = !this.isSearch;
            },
            resetPropertyPatentList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.propertyPatentList = [];
            },
            resetDialog() {
                this.propertyPatentState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      patentName: '', //专利名称
                      patentType: '', //专利类型
                      archiveNo: '', //案卷号
                      applyEntity: '', //申请人
                      applyDate: '', //申请日期
                      applyNo: '', //申请号
                      certificateInfo: '', //证件信息
                      applyAddress: '', //申请地址
                      postCode: '', //邮编
                      acceptStatus: '', //受理情况
                      applyfeeEnddate: '', //申请费缴纳截止时间
                      trialStatus: '', //审核情况
                      authorizeStatus: '', //授权情况
                      certificateStatus: '', //证书情况
                      saleMan: '', //业务员
                      authorizefeeAnnualfeeSituation: '', //授权费年费情况
                      engineer: '', //工程师
                      patentAgent: '', //专利代理人
                      qualityInspector: '', //质检人
                      remarks: '', //备注
                      contact: '', //联系人
                      telephone: '', //电话
                      qq: '', //QQ号
                      email: '', //邮箱
                      fax: '', //传真
                      signPrice: '', //签单价格
                      reminderDate: '', //下次缴费时间
                      paySituation: '', //缴费情况
                      patentStatus: '', //专利状态
                      urgentStatus: '', //紧急状态
                      companyId: [], //所属公司
                      reminderType:'',
                      startApplyDate:'',
                      endApplyDate:''
                };
                this.dataLabel1 = '';
                this.getPropertyPatentList();
            },
            closeDialog() {
                this.showDialog = false
                this.propertyPatent = {
                      patentName: '', //专利名称
                      patentType: '', //专利类型
                      archiveNo: '', //案卷号
                      applyEntity: '', //申请人
                      applyDate: '', //申请日期
                      applyNo: '', //申请号
                      certificateInfo: '', //证件信息
                      applyAddress: '', //申请地址
                      postCode: '', //邮编
                      acceptStatus: '', //受理情况
                      applyfeeEnddate: '', //申请费缴纳截止时间
                      trialStatus: '', //审核情况
                      authorizeStatus: '', //授权情况
                      certificateStatus: '', //证书情况
                      saleMan: '', //业务员
                      authorizefeeAnnualfeeSituation: '', //授权费年费情况
                      engineer: '', //工程师
                      patentAgent: '', //专利代理人
                      qualityInspector: '', //质检人
                      remarks: '', //备注
                      contact: '', //联系人
                      telephone: '', //电话
                      qq: '', //QQ号
                      email: '', //邮箱
                      fax: '', //传真
                      signPrice: '', //签单价格
                      reminderDate: '', //下次缴费时间
                      paySituation: '', //缴费情况
                      patentStatus: 1, //专利状态
                      urgentStatus: 1, //紧急状态
                      companyId: '', //所属公司
                      createTime: '', //
                      updateTime:''
                };
            },
            submitForm() {
                if (this.propertyPatentState == 'add') {
                    this.$refs.propertyPatentForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            this.propertyPatent.paySituation = this.propertyPatent.paySituation.join(",")
                            post(`/property/patent/add`,{ ...this.propertyPatent }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetPropertyPatentList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.propertyPatentState == 'edit') {
                    this.$refs.propertyPatentForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            this.propertyPatent.paySituation = this.propertyPatent.paySituation.join(",")
                            delete this.propertyPatent.company
                            console.log(this.propertyPatent)
                            post(`/property/patent/edit`,{ ...this.propertyPatent }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetPropertyPatentList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addPropertyPatent() {
                this.showDialog = true;
                this.propertyPatentState = 'add';
            },
            checkPropertyPatent(propertyPatentId) {
                console.log(propertyPatentId);
                this.currentPropertyPatentId = propertyPatentId;

                this.getPropertyPatentById();
                this.showDialog = true;
                this.propertyPatentState = 'check';
            },
            editPropertyPatent(propertyPatentId) {
                console.log('propertyPatent', propertyPatentId);
                if (propertyPatentId) {
                    this.currentPropertyPatentId = propertyPatentId;
                    this.getPropertyPatentById();
                } else {
                    this.propertyPatent = { ...this.propertyPatent, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.propertyPatentState = 'edit';
            },
            deletePropertyPatent(propertyPatentId) {
                let ids = '';
                if (propertyPatentId) {
                    ids = propertyPatentId;
                } else {
                    ids = this.multipleSelection.map((propertyPatent) => propertyPatent.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/property/patent/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetPropertyPatentList();
                                this.getPropertyPatentList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshPropertyPatentList() {
                this.resetPropertyPatentList();
                this.getPropertyPatentList();
            },
            getPropertyPatentList(query = {}) {
                this.loading = true;
                // console.log(this.dataLabel1)
                if(this.dataLabel1 != null){
                  this.queryForm.startApplyDate = this.dataLabel1[0]
                  this.queryForm.endApplyDate = this.dataLabel1[1]
                }else{
                  this.queryForm.startApplyDate = ''
                  this.queryForm.endApplyDate = ''
                }
                get(`/property/patent/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.propertyPatentList = res.page.list;
                        this.totalNum = res.page.total;
                        this.isSa = res.isSa
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getPropertyPatentById() {
                get(`/property/patent/get`,{ id: this.currentPropertyPatentId }).then((res) =>{
                    if(res.success){
                      this.propertyPatent = { ...this.propertyPatent, ...res.propertyPatent };
                      if(this.propertyPatentState != 'check'){
                        this.propertyPatent.paySituation = this.propertyPatent.paySituation.split(",")
                        for (const key in this.propertyPatent.paySituation) {
                          this.propertyPatent.paySituation[key] = Number(this.propertyPatent.paySituation[key])
                        }
                      }
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportPropertyPatentList() {
                //this.btnLoading = true;
                exprotExcel(`/property/patent/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/property/patent/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            // isImport() {
            //     this.isImportDate = true;
            // },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/property/patent/importData`,formData);
              this.refreshPropertyPatentList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getPropertyPatentList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getPropertyPatentList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.avatar {
  width: 180px;
  height: 180px;
  display: block;
}

::v-deep .el-upload--text {
  width: 80px;
  height: 32px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 180px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
::v-deep .warning-row {
    background: #f3bc6b;
}
::v-deep .success-row {
    background: #85d35e;
}
::v-deep .error-row {
    background: #f78989;
}
</style>